import React, { Component } from 'react';
import Navbar from '../components/navbar';
import ImageSlider from '../components/ImageSlider';
import AllProducts from '../components/AllProductHome';
import AllCategory from "../components/AllCategoryHome";
import Allcate from "../components/AllCateHome";
import AllBanner from "../components/AllBanner";
import TwosectionHome from "../components/HomePageTwosec";
import TopCategory from '../components/TopCategories';
import Footer from '../components/Footer';
import './home.css';
import MoreValueAdds from './MoreValueAdds';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '',
    };
  }

  componentDidMount() {
    // Extract the 'search' query parameter from the URL
    const params = new URLSearchParams(window.location.search);
    const searchLocation = params.get('search') || '';
    
    // Set the location state with the search parameter
    this.setState({ location: searchLocation });
  }

  handleLocationChange = (e) => {
    this.setState({ location: e.target.value });
  };

  render() {
    return (
      <div>
        <Navbar />
        <div className="body">
         
             <div className="homepage-body">
          {/* Main Banner Section */}
          <div className="main-banner-section">
            <div className="banner-container">
              <div className="category-sidebar">
                <Allcate />
              </div>
              <div className=''>
                <div className='slider-banner'>
                    <div className="slider-section">
                <ImageSlider />
              </div>
             
              <div className="right-banner">
                <AllBanner />
              </div> </div>
                     <MoreValueAdds/>
               </div>
       
          </div>
          
              </div>
             
            
           
             
              <AllCategory />
           
            <div className="container1 productSection mt-4">
              <h2 className="mb-4">Products</h2>
              {/* Pass the selected location as a prop to AllProducts */}
              <AllProducts location={this.state.location} />
            </div>
          </div>
         
        </div>
        <div className='container'>
        <h2 className="mb-4">Top Categories</h2>
        <TopCategory />
        </div>
       < Footer/>
      </div>
    );
  }
}

export default Index;
